import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "services",
    class: "w-full"
};
const _hoisted_2 = { class: "mb-16 md:flex justify-between items-end" };
const _hoisted_3 = { class: "text-sm font-mono uppercase tracking-widest opacity-50 mb-4 md:mb-0" };
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8" };
const _hoisted_5 = { class: "w-12 h-12 bg-softGray dark:bg-white/5 flex items-center justify-center mb-8 group-hover:bg-accent group-hover:text-white transition-colors duration-300 rounded-none" };
const _hoisted_6 = { class: "font-mono font-bold text-lg" };
const _hoisted_7 = { class: "text-2xl font-bold mb-4 tracking-tight" };
const _hoisted_8 = { class: "text-base opacity-70 leading-relaxed mb-8" };
const _hoisted_9 = { class: "flex flex-wrap gap-2" };
import { computed } from 'vue';
import { SERVICES_DATA, CONTENT } from '../constants';
import { useLanguage } from '../composables/useLanguage';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Services',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        const services = computed(() => SERVICES_DATA[language.value]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(text.value.sections.services), 1 /* TEXT */),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-[1px] flex-grow bg-black/10 dark:bg-white/10 ml-8 hidden md:block" }, null, -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "group p-8 bg-white dark:bg-darkGray border border-transparent hover:border-black/5 dark:hover:border-white/5 hover:shadow-xl dark:hover:shadow-2xl transition-all duration-500 ease-out rounded-none"
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(index + 1), 1 /* TEXT */)
                            ]),
                            _createElementVNode("h4", _hoisted_7, _toDisplayString(service.title), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(service.description), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.tags, (tag) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        key: tag,
                                        class: "text-xs font-mono uppercase px-2 py-1 bg-gray-100 dark:bg-white/5 text-gray-600 dark:text-gray-400 rounded-none"
                                    }, _toDisplayString(tag), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
